import { get } from '@didi/webx-js'
import http from '../lib/js/request'

const host = process.env.npm_config_mock ? '' : process.env.API_NORMAL
const apiPreSpike = process.env.npm_config_mock ? '' : process.env.API_PRE_SPIKE

export const URL = {
  ruleURL:
    'https://dpubstatic.udache.com/static/dpubimg/dpub2_project_50755/index_50755.html',
}

// const cityListAPI = 'https://winter-campaign.xiaojukeji.com/mpb/mpb/city/getCityList' // https://mpb.xiaojukeji.com
const commonCitiesListAPI =
  'https://bosp-api.xiaojukeji.com/quartz/volcano/quartz/city/lists/byGroup'
const shareConfigAPI = `${host}/goods/share`

// index, goodsDetail, personal
const userInfoAPI = `${host}/user/info`

// goodsDetail, spikeDetail
const goodsInfoAPI = `${host}/goods/info`
const orderCreateAPI = `${host}/order/create`
// goodsDetail
// index, spikeDetail
const syncTimeAPI = `${apiPreSpike}/sys/dateline`

// personal
const orderListAPI = `${host}/order/lists`
// personal, refund
const orderInfoAPI = `${host}/order/info`

// refund
const refundApplyAPI = `${host}/refund/apply`
const refundConfirmAPI = `${host}/refund/confirm`
const host1009 = '//member.xiaojukeji.com/paymember/web'
const orderInfo1009API = `${host1009}/refund/status`
const refundApply1009API = `${host1009}/refund/apply`
const refundConfirm1009API = `${host1009}/refund/confirm`
// 订单状态更新
const updateOrderAPI = `${host}/order/update`

// save money card mall
const pay_card_host = '//member.xiaojukeji.com/pios/paymember'
const cardListAPI = `${pay_card_host}/h5/save/cards/v2`
const cardOrderListAPI = `${pay_card_host}/h5/order/list`
const deleteCardOrderAPI = `${pay_card_host}/h5/order/delete`
export function getUserInfo(param, otherParams) {
  return http.get(userInfoAPI, param, otherParams)
}

export function getSyncTime(param, otherParams) {
  return http.get(syncTimeAPI, param, otherParams)
}

export function getOrderList(param, otherParams) {
  return http.get(orderListAPI, param, otherParams)
}

export function getOrderInfo(param, otherParams) {
  return http.get(orderInfoAPI, param, otherParams)
}

export function getOrderInfo1009(param, otherParams) {
  return http.get(orderInfo1009API, param, otherParams)
}

export function getRefundStatus1009(param, otherParams) {
  return http.get(refundApply1009API, param, otherParams)
}

export function refundConfirm1009(param, otherParams) {
  return http.get(refundConfirm1009API, param, otherParams)
}

export function getRefundStatus(param, otherParams) {
  return http.get(refundApplyAPI, param, otherParams)
}

export function refundConfirm(param, otherParams) {
  return http.get(refundConfirmAPI, param, otherParams)
}

// 城市列表
export const getCommonCitiesList = params =>
  get(commonCitiesListAPI, {
    params,
  })
// 查询业务线
export function getGoodsInfo(param, otherParams) {
  return http.get(goodsInfoAPI, param, otherParams)
}

export function createOrder(param, otherParams) {
  return http.post(orderCreateAPI, param, otherParams)
}

export function getShareConfig(params, otherParams) {
  return http.get(shareConfigAPI, params, otherParams)
}

export function updateOrder(params, otherParams) {
  return http.post(updateOrderAPI, params, otherParams)
}

export function getCardList(params, otherParams) {
  return http.get(cardListAPI, params, otherParams)
}

export function getCardOrderList(params, otherParams) {
  return http.get(cardOrderListAPI, params, otherParams)
}

export function deleteCardOrder(param, otherParams) {
  return http.post(deleteCardOrderAPI, param, otherParams)
}
